export const jqPauseRedirect = (redirectData) => {
	if (redirectData !== undefined) {
		let url = redirectData.pauseUrl,
			backQuery = redirectData.backUrl,
			whiteList = redirectData.whiteList,
			usePause = true;
		if (!window.location.href.includes(url) && usePause) {
			document.querySelectorAll("a[href*='https://'], a[href*='http://']").forEach((link) => {
				let external = true;
				whiteList.forEach((list, index) => {
					if (whiteList.includes("*")) {
						let whiteListHost = new RegExp("\\/" + list.host);
						if (whiteListHost.test(link.href)) {
							external = false;
						}
					} else {
						if (link.href.includes(list.host)) {
							external = false;
						}
					}
					if (index === whiteList.length - 1) {
						if (external) {
							link.href = url + encodeURIComponent(link.href) + backQuery + window.location.href;
						}
					}
				});
			});
		}
	}
};
